import { useMemo } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  DEFAULT_STOCKFISH_SCRIPT_URL,
  type AnalysisEngineOptions,
} from 'react-chess-core';
import { replayRefutationEngineOptions } from 'react-chess-replay-trainer';

const publicUrl = process.env.PUBLIC_URL ?? '';

/** Stockfish script URL resolved for this frontend bundle (honors CRA `PUBLIC_URL`). */
export const puzzleEngineOptions = {
  scriptUrl: `${publicUrl}${DEFAULT_STOCKFISH_SCRIPT_URL}`,
} as const satisfies AnalysisEngineOptions;

export const playTimeEngineOptions = {
  ...puzzleEngineOptions,
  depth: 10,
  multiPv: 6,
  priority: 0,
} as const satisfies AnalysisEngineOptions;

export const playTimeEngineOptionsMobile = {
  ...playTimeEngineOptions,
  depth: 8,
  multiPv: 5,
} as const satisfies AnalysisEngineOptions;

export const analysisModalEngineOptions = {
  ...puzzleEngineOptions,
  depth: 16,
  multiPv: 3,
  priority: 1,
} as const satisfies AnalysisEngineOptions;

export const usePlayTimeEngineOptions = (): AnalysisEngineOptions => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return useMemo(
    () => (isMobile ? playTimeEngineOptionsMobile : playTimeEngineOptions),
    [isMobile],
  );
};

/** Engine options for wrong-move refutation analysis (puzzles, review, replay, courses). */
export const useRefutationEngineOptions = (): AnalysisEngineOptions =>
  useMemo(
    () => ({
      ...puzzleEngineOptions,
      ...replayRefutationEngineOptions,
    }),
    [],
  );
